import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Menu, MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { MoreHoriz as MoreHorizIcon } from '@material-ui/icons';
import messages from '../PromotionsTable/PromotionManageButtons/messages.js';

const useStyles = makeStyles({
  manageButton: {
    marginRight: 5
  }
});

const ToursPromotionSummaryButton = ({ tourId, title, handleDeleteTourFromPromo }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const classes = useStyles();

  const handleOpenDropDown = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseDropDown = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        className={classes.manageButton}
        style={{ backgroundColor: '#fff' }}
        color="#fff"
        variant="contained"
        onClick={handleOpenDropDown}>
        <MoreHorizIcon />
      </Button>
      <Menu
        style={{ marginTop: '50px' }}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseDropDown}>
        <MenuItem onClick={() => handleDeleteTourFromPromo(tourId, title)}>
          <FormattedMessage {...messages.delete} />
        </MenuItem>
      </Menu>
    </div>
  );
};

export default ToursPromotionSummaryButton;
